import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        {
          text: 'تاریخ ورود',
          value: 'date',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'کد ملی',
          value: 'nationalCode',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره پرسنلی',
          value: 'personalNumber',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          isGroupable: true,
        },
        { text: 'نقش', value: 'role', align: 'center', isGroupable: true },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchRoleId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let fullName = '';
        if (data[i].firstName) {
          fullName += data[i].firstName + ' ';
        } else {
          fullName += '-';
        }
        if (data[i].lastName) {
          fullName += data[i].lastName;
        } else {
          fullName += '-';
        }
        if (data[i].lastLogInDate) {
          date = Vue.moment(data[i].lastLogInDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.tableItems.push({
          fullName: fullName,
          phoneNumber: data[i].phoneNumber ? data[i].phoneNumber : '-',
          date: date,
          nationalCode: data[i].nationalCode ? data[i].nationalCode : '-',
          personalNumber: data[i].personnelNumber ? data[i].personnelNumber : '-',
          role: data[i].roles ? data[i].roles : '-',
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCOnlineUsersReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchRoleId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchRoleId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCOnlineUsersReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchRoleId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchRoleId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
  },
};
